import { Box } from "@mui/material";
import { dataFetchFrequency } from "constants/componentsConstants";
import dayjs from "configs/dayjs.config";

import React, { useEffect, useState } from "react";
import { getDaysLeftIndicatorColor } from "utils/functions/getIndicatorColor";
import { calculateDaysLeft } from "./daysDiffUtilityFunction";

export const IndicatorBox = ({ children, targetDate, alertBeforeDays }) => {
  useEffect(() => {
    const intervalId = setInterval(() => {
      setDaysLeft(calculateDaysLeft(dayjs(targetDate)));
    }, dataFetchFrequency.timeSinceAndLeft);

    return () => clearInterval(intervalId);
  }, [targetDate]);

  const [daysLeft, setDaysLeft] = useState(
    calculateDaysLeft(dayjs(targetDate))
  );
  return (
    <Box color={getDaysLeftIndicatorColor(daysLeft, alertBeforeDays)}>
      {children}
    </Box>
  );
};
